import React from "react";

// import { connect } from "react-redux";
// import * as actionCreators from "../../../Store/actions/index";
import classes from "./CustomSelect.module.css";

const CustomSelect = (props) => {
    const itmes = props.list.map(listItem => {
        return (
            <li 
            key={listItem.name}
            onClick={()=>{
                if (listItem.name==='logout'){
                    props.logoutUser()
                    props.setShowSelect(false)
                    props.routeProp.history.push('/')
                }
                else if (listItem.name==='profile'){
                    props.setShowSelect(false)
                    props.routeProp.history.push('/Profile')
                }
            }}>
                {listItem.name}
            </li>
        );
    });
    return (
        props.show ?
            <ul className={classes.List}>
                {itmes}
            </ul>
            :
            null
    );
};

export default (CustomSelect);